// extracted by mini-css-extract-plugin
export default {"badgeCustom":"BoxStatus_badgeCustom__A58ND"};